import styled from 'styled-components'

const LayoutDiv = styled.div`
  padding: 8px;
`

export default LayoutDiv
